var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlame = function SvgFlame(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.076 1.007a.05.05 0 0 1 .053.001.04.04 0 0 1 .017.02.04.04 0 0 1 .002.026c-.188.675-1.113 4.586 2.23 7.125 3.267 2.483 3.367 6.22.933 8.715-2.91 2.988-7.943 2.462-10.11.497-1.525-1.376-4.295-5.864.45-9.616l.013-.01a.04.04 0 0 1 .036 0l.014.01c.116.447.921 3.269 3.067 3.632.1 0 .148-.04.1-.124-.633-1.11-3.483-6.776 3.195-10.276"
  })));
};
export default SvgFlame;